import { createActionGroup, props } from '@ngrx/store';
import type { ApiTypes } from '../../..';
import type { GeneralContactFormPayload, TestDriveFormPayload } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'distribution',
    events: {
        'Submit TestDrive Form': props<{ payload: TestDriveFormPayload; vehicle: ApiTypes.VehicleDetail }>(),
        'Submit GeneralContact Form': props<{ payload: GeneralContactFormPayload; vehicle: ApiTypes.VehicleDetail }>(),
        'Submit Distribution Form Response': props<{ success: boolean }>(),
        'Submit Distribution Form Loading': props<{ loading: boolean }>(),
    },
});
